<template>
    <div>
      <!--<a-tabs type="card" :activeKey='activeKey' @change='changeTabs'>-->
        <a-tabs type="card" :activeKey='activeKey'>
            <a-tab-pane key="10" tab="网关信息"></a-tab-pane>
         <!--   <a-tab-pane key="20" tab="正式环境"></a-tab-pane>-->
        </a-tabs>
        <a-spin :spinning="loadingTag">
            <div class='content'>
                <a-row class="title">
                    <a-col :span='4' class='tr trtitle'>
                        网关名称
                    </a-col>
                    <a-col :span='17' style='text-align:left;'>
                        网关地址
                    </a-col>
 
                    <a-col :span='3' class='pdr20'>
                        操作
                    </a-col>
                </a-row>
                <div v-for='(item,index) in callbackList' :key='index' class='item_content'>
                    <a-row class="title rows" :class='{noborder:index == callbackList.length - 1}'>
                        <a-col :span='4' class='tr'>
                            {{item.urlTypeValue}}
                        </a-col>
                      <!--  <a-col :span='17' style='text-align:left;' v-if='activeKey == "10"'>-->
                        <a-col :span='17' style='text-align:left;'  >
                            <a-input v-model:value="item.url" placeholder="网关地址" />
                        </a-col>
                        <!--<a-col :span='17' style='text-align:left;' v-else>
                            <a-input v-model:value="item.saveUrl" placeholder="网关地址" />
                        </a-col>-->
                        <a-col :span='3' class='operation' @click='saveUrlAction(item)'>
                            保存
                        </a-col>
                    </a-row>
                </div>
            </div>

            <!--<div class='btn_content' v-if='activeKey == "20"'>
                <a-button type="primary" class='submitBtn' @click="confirmOrder">
                    发布
                </a-button>
            </div>

            <div class='management' v-if='activeKey == "20"'>   
                <div class='ttitle'>接口管理</div>
                <div class='content' style='margin-top:11px'>
                    <a-row class="title">
                        <a-col :span='4' class='tr trtitle'>
                            网关名称
                        </a-col>
                        <a-col :span='17' style='text-align:left;'>
                            网关地址
                        </a-col>
    
                        <a-col :span='3' class='pdr20'>
                            状态
                        </a-col>
                    </a-row>
                    <div v-for='(item,index) in callbackList' :key='index' class='item_content'>
                        <a-row class="title rows" :class='{noborder:index == callbackList.length - 1}'>
                            <a-col :span='4' class='tr'>
                                {{item.urlTypeValue}}
                            </a-col>
                            <a-col :span='17' class='url_content' style='text-align:left;'>
                                {{item.url}}
                            </a-col>
                            <a-col :span='3'  @click='saveUrlAction(item)'>
                                <span class='user'>使用中</span>
                            </a-col>
                        </a-row>
                    </div>
                </div>
            </div>-->
        </a-spin>

    </div>
</template>
<script>
import { ref, watch } from 'vue'
import commonApi from '@axios/common'
import { useRouter, useRoute } from 'vue-router'
import { message,Modal } from 'ant-design-vue'

export default {
  name: 'platform',
  components: {

  },
  setup () {

      console.log("process: "+ process.env.NODE_ENV);
    const route = useRoute();

    let uid = route.query.id;
    const activeKey = ref(process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'test' ? '10' : '20');
      console.log("activeKey: "+ activeKey.value);
    
   /* const changeTabs = (tab) => {
        callbackList.value = [];
        activeKey.value = tab;
        getCallbackList();
    }   */

    let callbackList = ref([]);
    
    let loadingTag = ref(false)

    const getCallbackList = () => {
        let params = {
            appid : uid,
            env : activeKey.value
        }
        loadingTag.value = true
        commonApi.getCallback(params).then((res)=>{
            callbackList.value = res;
            loadingTag.value = false
        }).catch((err)=>{
            loadingTag.value = false
        })

    }

    getCallbackList();


    let xurl = ref('');

    const confirmOrder = () => {
        Modal.confirm({
          content: '发布后将全部覆盖掉现有接口，请再次确认是否发布？',
          onOk() {
            commonApi.pushUrl(uid).then(()=>{
                message.info('发布成功')
                getCallbackList();
            })
          },
          cancelText: "取消",
          okText: "确定",
          onCancel() {
              Modal.destroyAll();
          },
      });
        
    }

    const cancelOrder = () => {
        
    }

   /* const saveUrlAction = (item) => {
        /!*var process = process.env.NODE_ENV;
        console.log("process: "+ process);*!/
        console.log("process: "+ process.env.NODE_ENV);
        let url;
        if(activeKey.value == '10'){
            url = item.url;
        }else{
            url = item.saveUrl
        }
        if(!url){
            message.info('请输入地址');
            return
        }
        
        let params = {
            id : item.id,
            appId : uid,
            urlType : item.urlType,
            env : parseInt(activeKey.value),
            saveUrl : url
        }

        commonApi.saveUrl(params).then((res)=>{
            getCallbackList();
        })
    }*/

      const saveUrlAction = (item) => {
          /*var process = process.env.NODE_ENV;
          console.log("process: "+ process);*/
          console.log("process: "+ process.env.NODE_ENV);
          let url = item.url;

          if(!url){
              message.info('请输入地址');
              return
          }

          let params = {
              id : item.id,
              appId : uid,
              urlType : item.urlType,
              env : parseInt(activeKey.value),
              url: url,
              saveUrl : url
          }

          commonApi.saveUrl(params).then((res)=>{
              getCallbackList();
          })
      }


    


    return {    
        saveUrlAction,
        loadingTag,
        callbackList,
        cancelOrder,
        confirmOrder,
        xurl,
        activeKey,
        //changeTabs,
    }
  },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .pdr20{
        padding-right:35px;
    }
    .item_content{
        padding:0 20px;
    }
    .url_content{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6D7278;
    }
    .btn_content{
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;
    }   
    .submitBtn{
        background: #FFAB00;
        border-color:#FFAB00;
        width:93px;
        height: 40px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        border-radius: 5px;
    }
    .noborder{
        border: none!important;
    }
    .user{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #549700;
    }
    .management{
        margin-top: 24px;
        .ttitle{
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            background: #fff;
        }
    }
    .tr{
        text-align: left!important;
    }
    .confirm_order{
        margin-top: 38px;
        display: flex;
        justify-content: flex-end;
        .submitBtn,.concelBtn{
            width: 167px;
            height: 40px;

        }
        .submitBtn{
            background: #FFAB00;
            border-color:#FFAB00;
            margin-right: 17px;
        }
        .concelBtn{
            background: #F8F8F8;
            border-color:#F8F8F8;
            color:#000000;
        }
    }
    .operation{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6D7278;
        cursor: pointer;
        text-decoration: underline;
    }
    .tags{

        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5EB700;
    }
    .rows{
        background: #fff!important;
        border-bottom: 0.5px solid #DBDCE0;
        height: 54px;
    }

    .content{
        border-radius: 2px;
        border: 0.5px solid #DBDCE0;
      
    }
    .title{
        background: #F8F8F8;
        height: 55px;
        line-height: 55px;
    }

    .trtitle{
        padding-left:20px;
    }

    .title{
        ::v-deep(.ant-col){
            text-align: center;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
        }
    }


</style>
